import { useMutation } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

/**
 * VIB-634/VIB-647: oppdaterer passordet for innlogget bruker via
 * supabase.auth.updateUser. Brukes av ResetPasswordForm etter at brukeren
 * har klikket reset-lenken og Supabase har etablert en recovery-session.
 *
 * Wrapper auth-kallet i en TanStack Query mutation slik at komponenter
 * ikke trenger å importere supabase-klienten direkte (jf. CLAUDE.md §4).
 */
export function useUpdatePassword() {
  return useMutation({
    mutationFn: async (password: string) => {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw new Error(error.message);
    },
  });
}
